<template>
  <searches-groups-list-page
      resource-name="group_library"
      :is-initiated="groupsAreInitiated"
      :hide-filters="true"
      :data="groupsData"
      :no-data="groupsNoData"
      :all-loaded="groupsAllLoaded"
      can-load-more-string="groupsCanLoadMore"
      :is-busy="groupsAreBusy"
  />
</template>

<script>
// Components
import SearchesGroupsListPage from "../../components/boolean-search/SearchesGroupsListPage.vue";

// Mixins
import computedQueries from "../../mixins/boolean-search/computedQueries";

export default {
  name: "groups-list",

  mixins: [ computedQueries ],

  components: {
    SearchesGroupsListPage,
  }
}
</script>